import React, {useEffect, useMemo, useState} from 'react'
import MaterialTable from "material-table";
import {localization, modifyDefaultOptions} from "../../helpers/table";
import useAPI from "../../hooks/useAPI";
import moment from "moment";
import approvedStatus from '../../../img/icons/tableApproved.svg';
import notApprovedStatus from '../../../img/icons/tableProjOffice.svg';
import LoadingTable from "../table/LoadingTable";
import {Tooltip, useMediaQuery} from "@mui/material";
import Select from "react-select";
import {Button, Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {findLastIndex} from "lodash";

const currentYear = new Date().getFullYear();

export default function TabProjectRegistry(){
    const api = useAPI()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [projects, setProjects] = useState([])
    const [tags, setTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState<number[]>([])

    const media1400 = useMediaQuery('(min-width: 1400px)');
    const media1600 = useMediaQuery('(min-width: 1600px)');
    const media1800 = useMediaQuery('(min-width: 1800px)');
    const media2000 = useMediaQuery('(min-width: 2000px)');

    const tagOptions = useMemo(() => [
        {label: 'Проекты без тега', value: -1},
        ...tags.map(tag => ({
            label: tag.name,
            value: tag.id
        }))
    ], [tags])

    useEffect(() => {
        const getTags = async () => {
            const tags = await api.get('/mng/labels');
            setTags(tags)
        }
        getTags()
    }, []);

    useEffect(() => {
        const getProjects = async () => {
            setIsLoading(true);
            const projects = await api.get(`/stats/projs/list${selectedTags.length ? `?labels=[${selectedTags}]` : ''}`);
            setProjects(projects);
            setIsLoading(false);
        }
        getProjects();
    }, [selectedTags]);

    return <div className='projectRegistry'>
        <div className='projectRegistry-toolbar mb-4'>
            <Row>
                <Col xs={5}>
                    <Select
                        value={
                            selectedTags.length
                                ? tagOptions.filter(opt => selectedTags.includes(opt.value))
                                : {label: 'Все теги', value: null}
                        }
                        onChange={
                            (opts) => setSelectedTags(opts
                                .filter(opt => opt.value)
                                .map(opt => opt.value)
                            )
                        }
                        options={tagOptions}
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({...base, zIndex: 10000})
                        }}
                        isMulti
                        closeMenuOnSelect={false}
                        noOptionsMessage={_ => 'Тегов не найдено'}
                    />
                </Col>
                <Col xs={7} className='d-flex justify-content-end'>
                    <div>
                        <Button
                            variant='outline-primary'
                            as='a'
                            href='https://data.my1.urfu.ru/data/dashboards/projects'
                            style={{textDecoration: 'none'}}
                            target='_blank'
                            rel='noopener norefferer'
                        >
                            Рейтинги проектов
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col xs={6} className='d-flex gap-3'>
                    <div className='d-flex gap-2'>
                        <img src={notApprovedStatus} style={{width: 22, height: 18}}/>
                        <span>На рассмотрении</span>
                    </div>
                    <div className='d-flex gap-2'>
                        <img src={approvedStatus} style={{width: 22, height: 18}}/>
                        <span>Одобрен</span>
                    </div>
                </Col>
            </Row>
        </div>
        <LoadingTable loadingObject={{isLoading}}>
            <MaterialTable
                columns={[
                    {
                        title: 'Статус',
                        field: 'status',
                        render: rowData => <div className='d-flex gap-2'>
                            <img
                                src={
                                    rowData.lastApprovedVersionYear === currentYear
                                        ? approvedStatus
                                        : notApprovedStatus
                                }
                            />
                            <Tooltip title={
                                rowData.labels.length
                                    ? <div>{rowData.labels.map(label => <p>{label.name}</p>)}</div>
                                    : null
                            }>
                                <span style={{color: '#0D6EFD', fontSize: 20, cursor: 'default'}}>#</span>
                            </Tooltip>
                        </div>
                    },
                    {
                        title: 'Проект',
                        field: 'project',
                        render: rowData => <Link to={getProjectLink(rowData)}>{rowData.fullNumber} {rowData.name}</Link>,
                        cellStyle: {
                            minWidth: 400 + (findLastIndex([media1400, media1600, media2000], value => value) + 1) * 200
                        }
                    },
                    {
                        title: 'Руководитель проекта',
                        field: 'head',
                        render: rowData => <div>{rowData.head?.displayName}</div>,
                        cellStyle: {
                            minWidth: media2000 ? 300 : media1800 ? 250 : 170
                        }
                    },
                    {
                        title: 'Дата начала',
                        field: 'startDate',
                        render: rowData => <div>{moment(rowData.startDate).format('DD.MM.YYYY')}</div>
                    },
                    {
                        title: 'Дата окончания',
                        field: 'endDate',
                        render: rowData => <div>{moment(rowData.endDate).format('DD.MM.YYYY')}</div>
                    },
                ]}
                data={projects}
                options={modifyDefaultOptions({
                    filtering: false,
                    sorting: false,
                    toolbar: false,
                    maxBodyHeight: 'calc(100vh - 490px)',
                    headerStyle: {
                        position: 'sticky', boxShadow: '0 -4px 0 white'
                    }
                })}
                localization={localization}
            />
        </LoadingTable>
    </div>
}

const getProjectLink = (project) => {
    let projectLink = '';
    if(project.strategyId){
        projectLink += `/strats/${project.strategyId}`
    }
    if(project.portfId){
        projectLink += `/portfolios/${project.portfId}`
    }
    if(project.policyId && !project.strategyId){
        projectLink += `/policies/${project.policyId}`
    }
    projectLink += `/projs/${project.id}`
    return projectLink;
}
